module.exports = __webpack_public_path__ + "img/VN.888e2661.svg";